import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MarineInsuranceModel } from '@data-layer/models/marine-insurance';
import { UntypedFormGroup } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { IErrorForm } from '@shared/form-wrapper/interfaces';

@Component({
  selector: 'app-marine-insurance-quote-value-commodity-card',
  templateUrl: './marine-insurance-quote-value-commodity-card.component.html',
  styleUrls: ['./marine-insurance-quote-value-commodity-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceQuoteValueCommodityCardComponent {
  @Input() public marineInsurance: MarineInsuranceModel;
  @Input() public formGroup: UntypedFormGroup;

  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;

  public errors: IErrorForm = {
    required: 'FORM_ERROR.REQUIRED',
  };

  constructor(private cdr: ChangeDetectorRef) {}

  public updateInputsValidation(): void {
    this.cdr.markForCheck();
  }
}
